// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/cuboid.js';

import { paths } from '../generated/cuboid';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('cuboid', Original, paths);
